import {Ng1Controller, StateService, TargetState, Transition} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {DisposeBag} from "../../modules/DisposeBag";
import {DebounceFactory} from "../../modules/DebounceModule";
import {IFilterService} from "angular";
import {QbCustomerDto} from "../../model/QbCustomerDto";

export default class DashboardController implements Ng1Controller {
    private disposeBag = new DisposeBag();
    private leads: QbCustomerDto[];

    private leadGroups = [{
        name: 'New Leads Unassigned',
        filter: x => x.salesRep == null,
        leads: []
    }, {
        name: 'Leads with Activity Due',
        filter: x => x.nextActivityDueDate <= new Date(),
        leads: []
    }, {
        name: 'Open Leads',
        filter: x => x.isActive == true && x.leadStatus?.name != 'Closed' && x.leadStatus?.name != 'Lost',
        leads: []
    }, {
        name: 'Open Leads with No Activity',
        filter: x => x.nextActivityDueDate == null && x.isActive == true && x.leadStatus?.name != 'Closed' && x.leadStatus?.name != 'Lost',
        leads: []
    }
    ]

    $onInit(): void {
        this.refreshDebounce();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiOnParamsChanged', newValues, $transition$);
        this.$stateParams = newValues;
        this.refreshDebounce();
    }

    constructor(private $dataHub: DataHubService,
                private $debounce: DebounceFactory,
                private $filter: IFilterService,
                private $state: StateService, private $stateParams: any) {

        $dataHub.bindAllLead(() => this.leads, this.disposeBag);
        $dataHub.onLeadUpdated(_ => this.applyFilters(), this.disposeBag);
        $dataHub.onLeadRemoved(_ => this.applyFilters(), this.disposeBag);
        $dataHub.onConnected(this.refreshDebounce, this.disposeBag);
    }

    refreshDebounce = this.$debounce(() => this.refresh(), 500, false);

    refresh = () => {
        console.debug('refresh', this.$dataHub.isConnected)
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.leadSubscribeAndQuery(true)
            .then(ret => {
                this.leads = ret;
                this.applyFilters();
            })
    };

    applyFilters = this.$debounce(() => {
        this.leadGroups.forEach(lg => {
            lg.leads = this.leads.filter(lg.filter);
        })
    }, 250, false);


}
